/**
 * Eine einzelne beanstandete Stelle im Beraterprofil (NP20-1093).
 *
 * Die Pruefungen liefern diese Liste, die Badge-Zahlen leiten sich daraus ab —
 * damit Zahl und Hinweistext nicht auseinanderlaufen koennen. Gemeldet wird nur,
 * was das Speichern blockiert; Hinweise mit severity `warn`/`info` bleiben
 * draussen. Ein blockierendes Feld erzeugt genau eine Fundstelle, auch wenn es an
 * mehreren Grenzen gleichzeitig scheitert — genannt wird der erste zutreffende
 * Grund.
 */
export type ValidationSection =
  | 'profil'
  | 'personal'
  | 'education'
  | 'career'
  | 'trainings'
  | 'certificates'
  | 'projects'
  | 'tasks'
  | 'skills';

/** Bezug einer Fundstelle zur Aufgabe, an der sie haengt. */
export interface ValidationTaskRef {
  index: number;
  caption?: string;
}

export interface ValidationFinding {
  section: ValidationSection;
  /** Technischer Feldname, ueber den die Anzeige die Fundstelle ihrem Feld zuordnet. */
  field: string;
  /** i18n-Key der Feld-Beschriftung. */
  labelKey: string;
  /** i18n-Key des Grundes — derselbe Key, den der Bearbeitungsmodus am Feld zeigt. */
  reasonKey: string;
  /** Parameter des Grundes, z. B. die Mindestlaenge. */
  reasonParams?: Record<string, unknown>;
  /** Position innerhalb einer Liste (Ausbildung, Werdegang, Zertifikate, Projekte, …). */
  entryIndex?: number;
  task?: ValidationTaskRef;
}

export function findFieldFinding(
  findings: ValidationFinding[],
  field: string,
): ValidationFinding | null {
  return findings.find(finding => finding.field === field) ?? null;
}

export function findEntryFinding(
  findings: ValidationFinding[],
  entryIndex: number,
  field: string,
): ValidationFinding | null {
  return findings.find(
    finding => finding.field === field && finding.entryIndex === entryIndex
  ) ?? null;
}

export function findValueFinding(
  findings: ValidationFinding[],
  field: string,
  value: string,
): ValidationFinding | null {
  return findings.find(
    finding => finding.field === field && finding.reasonParams?.['value'] === value
  ) ?? null;
}
